export default function(data) {
    let source = 'google';
    let items = data.data.items.map(item=>({...item, source, id: item.family}));
    return {
        data: {
            data: items
        }
    };
}